function padDatePart(value: number): string {
  return value.toString().padStart(2, "0");
}

function parseDateParts(
  year: number,
  month: number,
  day: number,
): Date | undefined {
  const parsed = new Date(year, month - 1, day);

  if (
    parsed.getFullYear() !== year ||
    parsed.getMonth() !== month - 1 ||
    parsed.getDate() !== day
  ) {
    return undefined;
  }

  return parsed;
}

export function formatDatePickerValue(date: Date | undefined): string {
  if (!date) {
    return "";
  }

  return [
    padDatePart(date.getDate()),
    padDatePart(date.getMonth() + 1),
    date.getFullYear(),
  ].join(".");
}

export function parseDatePickerValue(value: string): Date | undefined {
  const trimmed = value.trim();

  if (!trimmed) {
    return undefined;
  }

  const localizedMatch = trimmed.match(/^(\d{1,2})[./](\d{1,2})[./](\d{4})$/);
  if (localizedMatch) {
    return parseDateParts(
      Number(localizedMatch[3]),
      Number(localizedMatch[2]),
      Number(localizedMatch[1]),
    );
  }

  const isoMatch = trimmed.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
  if (isoMatch) {
    return parseDateParts(
      Number(isoMatch[1]),
      Number(isoMatch[2]),
      Number(isoMatch[3]),
    );
  }

  return undefined;
}
